import type { DBCharacter } from '../../services/CharacterService';
import { freshCharacterEntryUrl } from './freshCharacterEntry';

/** Boot paths that mean "play the game" rather than one named party mode. On
 *  helix2000.com a visitor lands on `/resume` (the account roster). */
const STORY_ENTRY_PATHS: ReadonlySet<string> = new Set(['/', '/resume', '/intro', '/adventure', '/play']);

/**
 * D27 (2026-10-08) — a guest who presses "Play as guest" from a story entry
 * starts the story on the server-authored new-player start (the guest
 * character's `levelId`, the same entry map a new account's hero gets), never
 * on the roster hub `/resume` coerces to. Entering from a party mode (`/brawl`,
 * `/lobby`, …) keeps that mode's map: returns null and the caller starts the
 * game in place.
 */
export function guestCharacterEntryUrl(
  character: Pick<DBCharacter, 'levelId'>,
  current: URL,
): string | null {
  if (!STORY_ENTRY_PATHS.has(current.pathname)) return null;
  return freshCharacterEntryUrl(character.levelId, current);
}
